import React from "react";
import { Container } from "reactstrap";

const CookiePolicy = () => {
  return (
    <div>
      <Container fluid>
        <div
          style={{
            fontFamily:
              'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
            lineHeight: "1.7",
            color: "#222",
            backgroundColor: "#fafafa",
            padding: "2rem",
            maxWidth: "900px",
            margin: "auto",
          }}
        >
          <h1 style={{ color: "#0a3b61", borderBottom: "2px solid #0a3b61", paddingBottom: "0.3em", marginBottom: "1em" }}>
            PerfectCheck Cookie Policy
          </h1>
          <p className="meta" style={{ fontSize: "0.95em", color: "#555", marginBottom: "1.2em" }}>
            Last updated: October 2025
          </p>

          <p>
            PerfectCheck (“we”, “us”, or “our”) uses cookies and similar
            technologies to improve your experience when you visit our website
            and web application. This Cookie Policy explains what cookies are,
            how we use them, and your options for managing them.
          </p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>1. What Are Cookies</h2>
          <p>
            Cookies are small text files placed on your device when you visit a
            website. They help us make the site work efficiently, remember your
            preferences, and understand how you use our features so we can
            improve performance and security.
          </p>

          <p>We may also use similar technologies such as:</p>
          <ul style={{ marginLeft: "1.5em" }}>
            <li>
              <strong>Local Storage / Session Storage</strong> – for saving your
              settings or active session data
            </li>
            <li>
              <strong>Pixels / Tags / SDKs</strong> – to measure usage or
              conversions
            </li>
            <li>
              <strong>Device identifiers</strong> – for analytics and security
            </li>
          </ul>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>2. Who Sets the Cookies</h2>
          <p>
            <strong>First-party cookies:</strong> set by PerfectCheck directly.
          </p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>3. Types of Cookies We Use</h2>
          <p>
            We are using cookies that are <strong>strictly necessary</strong> for
            login, security, and site stability. These cannot be disabled.
          </p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>4. Cookies Used</h2>
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              margin: "1em 0",
              background: "#fff",
              boxShadow: "0 0 4px rgba(0,0,0,0.05)",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    background: "#f3f6f8",
                    textAlign: "left",
                  }}
                >
                  Cookie Name
                </th>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    background: "#f3f6f8",
                    textAlign: "left",
                  }}
                >
                  Provider
                </th>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    background: "#f3f6f8",
                    textAlign: "left",
                  }}
                >
                  Purpose
                </th>
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "10px",
                    background: "#f3f6f8",
                    textAlign: "left",
                  }}
                >
                  Duration
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  PHPSESSIONID
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  PerfectCheck
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Maintains secure login session
                </td>
                <td style={{ border: "1px solid #ddd", padding: "10px" }}>
                  Session
                </td>
              </tr>
            </tbody>
          </table>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>5. Legal Basis</h2>
          <p>We use:</p>
          <ul style={{ marginLeft: "1.5em" }}>
            <li>
              <strong>Legitimate interest</strong> for essential cookies (to
              deliver and protect our services).
            </li>
            <li>
              <strong>Your consent</strong> for all other cookies.
            </li>
          </ul>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>7. Third-Party Cookies</h2>
          <p>Currently, we do not have any third-party cookies.</p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>8. Your Rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct,
            delete, or restrict the use of your personal data. You can exercise
            these rights or withdraw consent by contacting us at{" "}
            <a href="mailto:support@perfectcheck.com" style={{ color: "#0a3b61" }}>
              support@perfectcheck.com
            </a>
            .
          </p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>9. Updates</h2>
          <p>
            We may update this Cookie Policy from time to time. Any changes will
            be posted on this page with a new “Last updated” date.
          </p>

          <h2 style={{ color: "#0a3b61", marginTop: "1.5em" }}>10. Contact</h2>
          <p>
            If you have any questions about this Cookie Policy or how we use
            cookies, contact the PerfectCheck Privacy Team via email:{" "}
            <a href="mailto:support@perfectcheck.com" style={{ color: "#0a3b61" }}>
              support@perfectcheck.com
            </a>
            .
          </p>
        </div>
      </Container>
    </div>
  );
};

export default CookiePolicy;
